import React from 'react';
import { Box, Typography } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  valueRaw: {
    marginTop: theme.spacing(0.5)
  },
  valueTypography: {
    fontWeight: 500,
    marginTop: theme.spacing(0.5)
  }
}));


export type EditableSectionRowItemProps = {
  title?: React.ReactNode;
  variant?: 'raw' | 'typography';
};


export const EditableSectionRowItem: React.FC<EditableSectionRowItemProps> = ({
  title,
  variant = 'typography',
  children,
}) => {
  const { classes } = useStyles();

  const content = React.useMemo(() => {
    if (variant === 'typography') {
      return (
        <Typography variant="body1" className={classes.valueTypography}>
          {children}
        </Typography>
      );
    }

    return (
      <Box className={classes.valueRaw}>
        {children}
      </Box>
    );
  }, [ variant, children, classes ]);

  return (
    <Box className={classes.root}>
      {title && <Typography color="textSecondary">{title}</Typography>}
      {content}
    </Box>
  );
};
